import React from 'react'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import mergeStyles from '@web/helpers/mergeStyles'

const Text = ({
  label,
  text,
  bold,
  style,
  noPadding,
  autoWidth,
  textAlign = 'left',
  onClick,
  spanText,
  textStyle
}) => {
  const { theme } = useTheme()
  const defaultStles = themeStyles(theme)
  const styles = mergeStyles(defaultStles, style)
  const txtStyle = textStyle || styles.text
  return (
    <div
      onClick={onClick}
      className={`${textAlign === 'right' ? 'pr0' : ''}`}
      style={{
        ...!noPadding && styles.container,
        ...bold && styles.header,
        ...autoWidth && styles.autoWidth,
        ...style
      }}
    >
      <p style={{ ...styles.label, textAlign }}>{label}</p>
      <p style={{ ...txtStyle, textAlign, ...bold && { fontWeight: 700 } }}>
        {text}
        {spanText && <span style={styles.spanText}>{' '}{spanText}</span>}
      </p>
    </div>
  )
}

export default Text
